import request from "root/js/request";

export const getWarehouseSupplyDistributionTable = async ({
  group_by,
  ids,
  brandsId,
  article,
  barcod,
  barcode_id__not_in,

  subject,
  cabinet_id,
  sort,
  limit,
  offset,
  q,
  by_subject_share_weight,
  sales_share_weight,
  exclude_region_clusters,
  is_excluded,
  forecast_period,
  with_seasonality,
  with_in_way_stocks,
  with_seasonality_spikes,
  with_mp_growth,
  with_trend,
  with_abc_xyz_cz_excluded,
  with_cancel_share,
  with_return_share,
  with_company_plan,
  fbo_share,
  sales_share_history_period,
  product_id__icontains,
  ...rest
}) => {
  const response = await request({
    url: "/analytics/forecasting/warehouse_supply_distribution_table/",
    method: "get",
    params: {
      cabinet_id,
      category_id__in: ids,
      brand_id__in: brandsId,
      supplier_article__in: article,
      barcode__in: barcod,

      subject_id__in: subject,
      group_by,
      sales_share_history_period,
      order_by: sort,
      limit,
      offset,
      q,
      by_subject_share_weight,
      sales_share_weight,
      exclude_region_clusters,
      is_excluded,
      forecast_period,
      with_seasonality,
      with_in_way_stocks,
      with_seasonality_spikes,
      with_mp_growth,
      with_trend,
      with_abc_xyz_cz_excluded,
      with_cancel_share,
      with_return_share,
      with_company_plan,
      fbo_share,
      product_id__icontains,
      ...rest,
    },
  });
  return response.data;
};
